exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay--active:before{opacity:1!important}[dir] .overlay--active:before{background:rgba(0,0,0,.5)!important}.dialog{overflow:hidden!important;overflow-y:auto!important}[dir] .dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-68146a1f","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/currencyRate/addEdit.vue
// module id = 1432
// module chunks = 0